import Link from 'components/link/Link'
import { Language } from 'types/language'
import { Button } from '@boltenergy-be/design-system'
import { checkIsLink } from 'features/dynamic-tariff/components/quiz-action-button/utils'
import { useRouter } from 'next/router'
import { QuizActionButtonProps } from 'features/dynamic-tariff/components/quiz/types'
import { memo, PropsWithChildren } from 'react'

const QuizActionButton = memo(({ actionCard, variant, className, children }: PropsWithChildren<QuizActionButtonProps>) => {
  // Router
  const { locale } = useRouter()

  return (
    <>
      {checkIsLink(actionCard) ? (
        <Link
          representation="button"
          href={actionCard.externalUrl?.(locale as Language) || actionCard.internalRoute}
          external={!!actionCard.externalUrl?.(locale as Language)}
          {...{ variant, className }}
        >
          {children}
        </Link>
      ) : (
        <Button onClick={actionCard.action} {...{ variant, className }}>
          {children}
        </Button>
      )}
    </>
  )
})

QuizActionButton.displayName = 'QuizActionButton'

export default QuizActionButton
